import { Link as RouterLink } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { useAuthContext } from './useAuthContext';
import LoadingScreen from '../components/loading-screen/LoadingScreen';
import { Roles } from '../utils/owner-portal/userConstants';
import { Button } from '../components/ui/Button';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: Roles[];
  children: React.ReactNode;
};

export default function RoleBasedGuard({ hasContent, roles, children }: RoleBasedGuardProp) {
  // Logic here to get current user role
  const { user } = useAuthContext();

  if (!user) {
    return <LoadingScreen />;
  }

  const currentRole = user.role;

  if (typeof roles !== 'undefined' && !roles.includes(currentRole)) {
    return hasContent ? (
      <div className="container mx-auto px-4 text-center">
        <div className="animate-in fade-in slide-in-from-bottom-5 duration-500">
          <h3 className="mb-4 text-3xl font-bold">Permission Denied</h3>
        </div>

        <div className="animate-in fade-in slide-in-from-bottom-5 duration-500 delay-100">
          <p className="text-muted-foreground">You do not have permission to access this page</p>
        </div>

        <div className="animate-in fade-in zoom-in-95 duration-500 delay-200 my-10 sm:my-20">
          <ShieldX className="mx-auto h-32 w-32 text-muted-foreground" />
        </div>

        <Button asChild size="lg">
          <RouterLink to="/">Go to Home</RouterLink>
        </Button>
      </div>
    ) : null;
  }

  return <>{children}</>;
}
